<template>
  <div style="display:flex; justify-content: center;">
    <div class="lawyer-card">
      <img :src="lawyer.avatar" alt="Lawyer Avatar" height="137" class="mb-4"/>
      <h3 class="grey-darken4">{{ lawyer.name }}</h3>
      <p class="mb-0 mt-1 grey-darken2">{{ lawyer?.profession }}</p>
      <p class="grey-darken2">{{ lawyer.office }}</p>
      <img src="@/assets/img/landing-page/quote_icon.svg" alt="Quote Icon" class="my-3"/>
      <p class="quote">{{ lawyer.quote }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LawyerCardItem',
    props: {
        lawyer: {
        type: Object,
        required: true,
        },
    },
  }
</script>

<style lang="scss" scoped>
@import "vuetify/settings";
@import "@/scss/border-tokens";
@import "@/scss/box-shadow-tokens";

.lawyer-card {
  display:flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  padding: 20px;
  // Rounded from 19px, no matching token, closest is border-radius-4 (12px) (AB#3108019).
  @include border-radius('border-radius-4');
  background: white;
  border: 1px solid rgb(var(--v-theme-border-primary));
  @include box-shadow('box-shadow-medium');
  text-align: center;
  margin: 40px;
  margin-bottom: 20px;
  @media #{map-get($display-breakpoints, 'xs')}{
    margin: 40px 20px;
  }
}
.quote {
  font-weight: 400;
  font-size: 16px;
  color: rgb(var(--v-theme-grey-800));
}
.grey-darken2 {
  color: rgb(var(--v-theme-grey-700));
}
.grey-darken4 {
  color: rgb(var(--v-theme-grey-900));
}
</style>
